import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./lib/auth";
import Home from "./pages/Home";
import Quiz from "./pages/Quiz";
import Resources from "./pages/Resources";
import Approach from "./pages/Approach";
import Impact from "./pages/Impact";
import About from "./pages/About";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import PostRedirect from "./pages/PostRedirect";

function PublicShell({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  if (isAdmin) return children;
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Toaster position="top-center" richColors />
          <PublicShell>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/approach" element={<Approach />} />
              <Route path="/impact" element={<Impact />} />
              <Route path="/about" element={<About />} />
              <Route path="/quiz" element={<Quiz />} />
              <Route path="/resources" element={<Resources />} />

              {/* Legacy Wix blog URL → blog.medstry.in (preserves SEO) */}
              <Route path="/post/:slug" element={<PostRedirect />} />
              <Route path="/post" element={<PostRedirect />} />

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </PublicShell>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
